let initPromise: Promise<void> | null = null

export function useLordicon(): Promise<void> {
  if (!initPromise) {
    initPromise = Promise.all([
      import('@lordicon/element'),
      import('lottie-web/build/player/lottie_light'),
    ]).then(([{ defineElement }, { default: lottie }]) => {
      if (!customElements.get('lord-icon')) {
        defineElement(lottie)
      }
    }).catch((err) => {
      initPromise = null
      // @ts-expect-error - log is globally declared
      log?.error('[useLordicon] Failed to initialize:', err)
      throw err
    })
  }
  return initPromise
}
